const AttorneyAgentQuery = (id) => {
    return `
    query {
      deleteAgent(id: "${id}")
    }
    `
}

export default AttorneyAgentQuery